module.exports = __webpack_public_path__ + "fonts/500-normal-greek.4e0ca8b.woff2";